import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=bdb2a9e2&scoped=true"
import script from "./searchForm.vue?vue&type=script&lang=js"
export * from "./searchForm.vue?vue&type=script&lang=js"
import style0 from "./searchForm.vue?vue&type=style&index=0&id=bdb2a9e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb2a9e2",
  null
  
)

export default component.exports